import {
  useSharedSpaceMarketValidations,
  type ISpaceMarketValidations,
} from '@gem/modules/validations';

import { spaceMarketLinkAsyncValidation } from '../fields/fields';

export const useSpaceMarketValidations = (): ISpaceMarketValidations => {
  return useSharedSpaceMarketValidations({
    spaceMarketLinkAsyncValidation,
  });
};
